import React from 'react'

// STYLES // 
import './stylesBuyCard.scss'

function BuyCard({streamName, streamLogo, buyLogo, buyName}) {

  const IMG_PATH= "https://image.tmdb.org/t/p/original"

  return (
    <div className='buyCard'>
        <img className='buyCard_image' src={ `${IMG_PATH}${buyLogo}`} alt='moviePoster' />
        <p className='buyCard_text'> {buyName} </p>
    </div>

  )
}



export default BuyCard




